/** @jsxImportSource @emotion/react */
import { useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import NotificationContext from 'contexts/notificationContext';
import {
  Modal,
  Select,
  Button,
  ShortText,
  Icon,
} from 'components/common';
import api from 'api';

import * as styles from './AddGraduateAttestationModal.styles';

const AddGraduateAttestationModal = ({
  isSendAttestationModalOpen,
  setModalSendAttestation,
  fetchSeekerAttestation,
}) => {
  const { candidateId } = useParams();
  const { setNotification, setNotificationContent } = useContext(NotificationContext);
  const [formData, setFormData] = useState({
    attestationType: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const showNotification = (type, message) => {
    setNotification(true);
    setNotificationContent({ type, message });
  };

  const closeModal = () => {
    setFormData({
      attestationType: '',
    });
    setModalSendAttestation();
  };

  const buildPayload = () => ({
    attestation_type: formData.attestationType,
  });

  const handleSendEmail = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    const payload = buildPayload();

    setIsSubmitting(true);
    try {
      const { data } = await api.sendEmailAttestation(candidateId, payload);
      await fetchSeekerAttestation();
      showNotification('success', data.message);
      closeModal();
    } catch (error) {
      showNotification('error', error.response?.data?.message || 'Failed to send attestation email');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      styles={styles.modalStyles}
      isModalOpen={isSendAttestationModalOpen}
      setModal={closeModal}
    >
      <form css={styles.containerStyles}>
        <div css={styles.titleContainerStyles}>
          <ShortText>add graduate attestation</ShortText>
          <Button type="button" onClick={closeModal} disabled={isSubmitting}>
            <Icon name="times" />
          </Button>
        </div>
        <div css={styles.formRowContainerStyles}>
          <div css={styles.halfColumnContainerStyles}>
            <ShortText styles={styles.labelStyles}>Attestation Status</ShortText>
            <Select
              className="full"
              containerStyles={styles.inputContainerStyles}
              styles={styles.selectStyles}
              iconCustomStyles={styles.selectIconStyles}
              name="attestationType"
              value={formData.attestationType}
              onChange={handleChange}
              options={[
                {
                  label: 'hired',
                  value: 'hired',
                },
                {
                  label: 'waived',
                  value: 'waived',
                },
              ]}
              placeholder="choose status"
              disabled={isSubmitting}
            />
          </div>
        </div>
        <Button
          type="button"
          onClick={handleSendEmail}
          styles={styles.buttonStyles}
          disabled={isSubmitting || !formData.attestationType}
        >
          {isSubmitting ? 'Sending...' : 'Send'}
        </Button>
      </form>
    </Modal>
  );
};

AddGraduateAttestationModal.propTypes = {
  isSendAttestationModalOpen: PropTypes.bool.isRequired,
  setModalSendAttestation: PropTypes.func.isRequired,
  fetchSeekerAttestation: PropTypes.func.isRequired,
};

export default AddGraduateAttestationModal;
